var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isValidReportYear } from "./validationUtils";
export var INITIAL_LAST_RECEIVED_FILTER = {
    lastReceivedYear: "",
    lastReceivedIncludeOlder: false,
    neverReceived: false,
};
export var LAST_RECEIVED_ERROR_CODES = [
    "LAST_RECEIVED_FILTER_REQUIRES_LIBRARY",
    "LAST_RECEIVED_SORT_REQUIRES_LIBRARY",
    "INVALID_LAST_RECEIVED_YEAR",
    "LAST_RECEIVED_INCLUDE_OLDER_REQUIRES_YEAR",
];
export var hasLastReceivedYear = function (value) {
    return value.trim() !== "";
};
export var lastReceivedYearError = function (value) {
    var year = value.trim();
    if (year === "")
        return null;
    return isValidReportYear(year) ? null : "invalid";
};
export var normalizeLastReceivedFilter = function (values) { return ({
    lastReceivedYear: values.lastReceivedYear.trim(),
    lastReceivedIncludeOlder: values.lastReceivedIncludeOlder &&
        hasLastReceivedYear(values.lastReceivedYear),
    neverReceived: values.neverReceived,
}); };
export var isLastReceivedFilterActive = function (values) {
    return hasLastReceivedYear(values.lastReceivedYear) || values.neverReceived;
};
/**
 * The year goes out as typed, valid or not: the backend is the one place that validates it and
 * answers with the year's own error code, so a hand-edited URL fails loudly instead of being
 * silently filtered without the year.
 */
export var toLastReceivedQueryParams = function (values) {
    var _a = normalizeLastReceivedFilter(values), lastReceivedYear = _a.lastReceivedYear, lastReceivedIncludeOlder = _a.lastReceivedIncludeOlder, neverReceived = _a.neverReceived;
    return __assign(__assign(__assign({}, (lastReceivedYear && { lastReceivedYear: lastReceivedYear })), (lastReceivedIncludeOlder && { lastReceivedIncludeOlder: true })), (neverReceived && { neverReceived: true }));
};
